module.exports = __webpack_public_path__ + "static/media/ngo.caf0fc51.svg";